import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function ListIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M14 8H6m8-3.857H6m8 7.714H6M3.333 8a.655.655 0 0 1-.666.643A.655.655 0 0 1 2 8c0-.355.298-.643.667-.643.368 0 .666.288.666.643m0-3.857a.655.655 0 0 1-.666.643A.655.655 0 0 1 2 4.143c0-.355.298-.643.667-.643.368 0 .666.288.666.643m0 7.714a.655.655 0 0 1-.666.643.655.655 0 0 1-.667-.643c0-.355.298-.643.667-.643.368 0 .666.288.666.643" /></svg>
  );
}

export default ListIcon;
